import { EditorPanel } from "@/components/EditorPanel";
import { TimelinePanel } from "@/components/TimelinePanel";
import { DateEditorModal } from "@/components/DateEditorModal";
import { EditorProvider } from "@/lib/editorContext";
import { ThemeProvider } from "@/lib/theme";
import { ThemeToggle } from "@/components/ThemeToggle";
import "./index.css";

function AppLayout() {
  return (
    <div className="flex h-screen flex-col bg-background text-foreground">
      <main className="flex flex-1 overflow-hidden p-6">
        <div className="flex h-full flex-1 flex-col">
          <div className="flex h-full flex-1 flex-col rounded-4xl border border-border bg-card/80 p-6 shadow-none backdrop-blur">
            <div className="flex h-full flex-1 flex-col gap-6">
              <section className="flex h-full min-h-0 flex-1">
                <EditorPanel />
              </section>
              <section className="flex h-full min-h-0 flex-1">
                <TimelinePanel />
              </section>
            </div>
          </div>
        </div>
      </main>
      <DateEditorModal />
      <ThemeToggle className="fixed bottom-4 right-4 z-50" />
    </div>
  );
}

export function App() {
  return (
    <ThemeProvider>
      <EditorProvider>
        <AppLayout />
      </EditorProvider>
    </ThemeProvider>
  );
}

export default App;
